const initialState = {
  developer: false,
};

export default initialState;
